import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.gatewayData ? _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.table.eui'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "macAddress",
      "append-icon": 'fal fa-copy'
    },
    on: {
      "click:append": function ($event) {
        return _vm.copyToClipboard($event, _vm.gatewayData.eui);
      }
    },
    model: {
      value: _vm.gatewayData.eui,
      callback: function ($$v) {
        _vm.$set(_vm.gatewayData, "eui", $$v);
      },
      expression: "gatewayData.eui"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.mac')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.account'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "accountTitle"
    },
    model: {
      value: _vm.accountTitle,
      callback: function ($$v) {
        _vm.accountTitle = $$v;
      },
      expression: "accountTitle"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.account')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "value": `${_vm.gatewayData.originator.title || ''} (ID ${_vm.gatewayData.originator.id || _vm.gatewayData.properties.originator.id})`,
      "disabled": _vm.gatewayData.originator.id !== undefined,
      "label": _vm.$i18n_t('NiotaClassic.Devices.table.originator'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": "",
      "hide-details": "auto",
      "name": "originatorTitle",
      "error": _vm.gatewayData.originator.id === undefined
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.originator')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.serialNr'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "serialNr"
    },
    model: {
      value: _vm.gatewayData.properties.serialNr,
      callback: function ($$v) {
        _vm.$set(_vm.gatewayData.properties, "serialNr", $$v);
      },
      expression: "gatewayData.properties.serialNr"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.serialNr')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.firmwareVersion'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "firmwareVersion"
    },
    model: {
      value: _vm.gatewayData.properties.firmwareVersion,
      callback: function ($$v) {
        _vm.$set(_vm.gatewayData.properties, "firmwareVersion", $$v);
      },
      expression: "gatewayData.properties.firmwareVersion"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.firmwareVersion')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.group'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "group"
    },
    model: {
      value: _vm.gatewayData.properties.group,
      callback: function ($$v) {
        _vm.$set(_vm.gatewayData.properties, "group", $$v);
      },
      expression: "gatewayData.properties.group"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.hints.group')))])], 1), _vm.gatewayData.properties && _vm.gatewayData.properties.simCard ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3",
      "sm": "6",
      "xl": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.simCardNo'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "group"
    },
    model: {
      value: _vm.gatewayData.properties.simCardNo,
      callback: function ($$v) {
        _vm.$set(_vm.gatewayData.properties, "simCardNo", $$v);
      },
      expression: "gatewayData.properties.simCardNo"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.simCard')))])], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-file-alt",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.generally'),
      "offset": 24
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Common.table.createdAt'),
      "value": _vm.localizeDate(_vm.gatewayData.createdAt)
    }
  })], 1), _vm.isFirefly ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'link',
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.fireflyOrganization'),
      "link": `${_vm.gatewayData.datasource.server_rest ? `https://${_vm.gatewayData.datasource.server_rest}` : _vm.$store.state.app.fireflyUrl}/organizations/${_vm.getFireflyOrganizationId(_vm.gatewayData)}/gateways`,
      "iconColor": _vm.color,
      "itemImage": _vm.getDatasourceImage(_vm.gatewayData) || null
    }
  })], 1) : _vm._e(), _vm.getGwManagementToolLink(_vm.gatewayData) ? _c(VCol, {
    staticClass: "py-0 mt-4 mb-0",
    attrs: {
      "cols": "12",
      "md": "2",
      "sm": "6",
      "lg": "2",
      "xl": "2"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'link',
      "label": _vm.$i18n_t('NiotaClassic.GWMonitoring.form.gwManagementToolLink'),
      "link": _vm.getGwManagementToolLink(_vm.gatewayData),
      "iconColor": _vm.color
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-align-left",
      "title": _vm.$i18n_t('NiotaClassic.Devices.details.description'),
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.gatewayData.description || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)])], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.gatewayData.properties ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.GWMonitoring.attachments'),
      "icon": "fa-file-pdf",
      "offset": 24
    }
  }, [_c('div', {
    staticClass: "pt-4"
  }, [_c(VSimpleTable, {
    staticClass: "mt-2 file-table",
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', _vm._l(_vm.gatewayData.properties.attachments, function (item) {
    return _c('tr', {
      key: item.id,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function ($event) {
          return _vm.clickManufacturerFile(item);
        }
      }
    }, [_c('td', {
      staticClass: "pt-0 pb-0 pl-2 pr-0 text-truncate",
      staticStyle: {
        "max-width": "1px"
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _c('td', {
      staticClass: "pt-0 pb-0 pl-0 pr-2 text-right",
      staticStyle: {
        "width": "90px"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.readableFileSizeFromBytes(item.size)) + "\n                ")])]);
  }), 0)])], 1)]) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": _vm.$i18n_t('NiotaClassic.Devices.details.status'),
      "offset": "24",
      "icon": "fa-exclamation-triangle"
    }
  }, [_c(VRow, [!isNaN(_vm.gwLastPacketHours) ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.status'),
      "value": _vm.formatLastPacketTime(_vm.gwLastPacketHours),
      "iconColor": _vm.gwState,
      "type": "icon",
      "icon": "circle",
      "iconType": "fas"
    }
  })], 1) : _vm._e(), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.warningLevel'),
      "value": `> ${_vm.formatLastPacketTime(_vm.gwWarningLevel)}`,
      "iconColor": _vm.getColor('warning'),
      "type": "icon",
      "icon": "siren-on"
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.details.alertLevel'),
      "value": `> ${_vm.formatLastPacketTime(_vm.gwAlertLevel)}`,
      "iconColor": _vm.getColor('error'),
      "type": "icon",
      "icon": "sensor-alert"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm.statistics ? _c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "icon": "fa-chart-bar",
      "title": _vm.$i18n_t('NiotaClassic.Devices.form.statistics'),
      "offset": 24
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.numberOfPackets')))])]), _c(VCol, {
    staticClass: "mb-0 mt-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.timeFrames,
      "item-text": "name",
      "return-object": "",
      "solo": "",
      "disabled": _vm.loadingMetrics
    },
    on: {
      "change": _vm.selectTimeFrame
    },
    model: {
      value: _vm.selectedTimeFrame,
      callback: function ($$v) {
        _vm.selectedTimeFrame = $$v;
      },
      expression: "selectedTimeFrame"
    }
  })], 1)], 1), _c(VRow, [_vm.packetsBar.individual && _vm.packetsBar.individual.length ? _c(VCol, {
    staticClass: "charts-min-height",
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loadingMetrics ? _c('niota-classic-charts-bar', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.packetsBar
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@3"
    }
  })], 1) : _vm._e(), _vm.rssiLsnrGraph.individual && _vm.rssiLsnrGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.rssiLsnr')))])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.rssiLsnrGraph
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e(), _vm.sfGraph.individual && _vm.sfGraph.individual.length ? _c(VCol, {
    staticClass: "charts-line-min-height",
    attrs: {
      "cols": "12"
    }
  }, [_c(VCardText, {
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "text-right",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "float-left label pb-2"
  }, [_c('h6', [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.GWMonitoring.form.spreadingFactor')) + "\n                ")])])])], 1)], 1), !_vm.loadingMetrics ? _c('niota-classic-charts-line', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "height": 200,
      "multi-chart-data-t": _vm.sfGraph,
      "options": _vm.sfGraphOptions
    }
  }) : _c(VSkeletonLoader, {
    attrs: {
      "type": "table-row-divider@4"
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };